const DEFAULT_RUNTIME_ENVIRONMENT = Object.freeze({
  testEnvironmentNotice: Object.freeze({ enabled: false })
});

export function normalizeRuntimeEnvironment(value) {
  return {
    testEnvironmentNotice: {
      enabled: value?.testEnvironmentNotice?.enabled === true
    }
  };
}

export async function loadRuntimeEnvironment(fetchImpl = window.fetch.bind(window)) {
  try {
    const response = await fetchImpl('/runtime-environment.json', { cache: 'no-store' });
    if (!response.ok) return DEFAULT_RUNTIME_ENVIRONMENT;
    return normalizeRuntimeEnvironment(await response.json());
  } catch (error) {
    console.warn('Runtime environment configuration is unavailable; using safe defaults.', error);
    return DEFAULT_RUNTIME_ENVIRONMENT;
  }
}

export { DEFAULT_RUNTIME_ENVIRONMENT };
